//文字コードはutf-8

/* 絞り込みフィルター（accordion toggle）
========================================================*/
export function initFilter() {
    const toggles = document.querySelectorAll('.jsFilterToggle');
    if (!toggles.length) return;

    toggles.forEach(function (toggle) {
        const targetId = toggle.getAttribute('aria-controls');
        const body = targetId ? document.getElementById(targetId) : toggle.nextElementSibling;
        if (!body) return;

        // Set initial hidden state
        $(body).hide();

        toggle.addEventListener('click', function () {
            var isExpanded = toggle.getAttribute('aria-expanded') === 'true';

            if (isExpanded) {
                toggle.setAttribute('aria-expanded', 'false');
                $(body).slideUp(300);
            } else {
                toggle.setAttribute('aria-expanded', 'true');
                $(body).slideDown(300);
            }
        });
    });
}
